export default __webpack_public_path__ + "static/media/emaForm.8e1b21bd.JPG";